import React, { ReactNode } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { NavLink as RRNavLink } from 'react-router-dom';
import { translationForMts } from 'easit--localization';
import { IGlobalRenderTelemetryService } from 'eTip--common';

export enum PageType {
    EventList,
    EventDetail,
    EventDetails,
    Calendar
}

export interface INavigationPaths {
    home?: string;
    liveEvent?: string;
    eventsList?: string;
    favorites?: string;
    calendar?: string;
}

export interface ITopNavigationProps {
    soundSelection: ReactNode;
    paths: INavigationPaths;
    entrancePageGlobalRenderTelemetry: IGlobalRenderTelemetryService;
}

export const TopNavigation: React.FC<ITopNavigationProps> = (props: ITopNavigationProps) => {
    const t = translationForMts();

    let menuFragment = <ul className="nav live-top-navigation" data-test-role="live-top-navigation">
        <NavItem> {/* onClick and push in navlink is for SEO */}
            <NavLink tag={RRNavLink} to={props.paths.home} onClick={/* for SEO */() => { props.entrancePageGlobalRenderTelemetry.start(); return false; }} isActive={(_match: any, location: any) => {
                return location.pathname === props.paths.home || location.pathname === props.paths.eventsList;
            }} data-test-role="live-top-navigation__item--link" data-id="home">
                {t.liveMenu_overview}
            </NavLink>
        </NavItem>

        <NavItem>
            <NavLink tag={RRNavLink} to={props.paths.favorites} isActive={(_match: any, location: any) => {
                return location.pathname === props.paths.favorites;
            }} data-test-role="live-top-navigation__item--link" data-id="favorites">
                {t.liveMenu_favourites}
            </NavLink>
        </NavItem>

        <NavItem>
            <NavLink tag={RRNavLink} to={props.paths.liveEvent} isActive={(_match: any, location: any) => {
                return location.pathname === props.paths.liveEvent;
            }} data-test-role="live-top-navigation__item--link" data-id="event">
                {t.liveMenu_event}
            </NavLink>
        </NavItem>

        <NavItem>
            <NavLink tag={RRNavLink} to={props.paths.calendar} isActive={(_match: any, location: any) => {
                return location.pathname === props.paths.calendar;
            }} data-test-role="live-top-navigation__item--link" data-id="calendar">
                {t.liveMenu_calendar}
            </NavLink>
        </NavItem>
        {!__IsMTSTipos__ && props.soundSelection}
    </ul>;

    return <>
        <div className="w-100 d-flex justify-content-between align-items-center mb-2"></div>
        {
            __IsMTSTipos__ ? <div className="d-flex top-navigation">
                {menuFragment}
                {props.soundSelection}
            </div>
                :
                menuFragment
        }
    </>
}